<template>
    <div @click="addChosenProduct()"  class="product-container hover smake-product-container d-flex flex-column" style="height: 100%;">
        <div class="d-flex justify-center align-center" style="z-index: 0; position: relative;">
            <v-img :id="product.id" style="position:relative;" max-width="190px" max-height="190px" :src="$root.getSrc('/'+ this.product.photos)" contain>
                <v-img v-if="printArea" :style="{'left': printArea.x+'px', 'top': printArea.y+'px', 'height': printArea.height+'px', 'width': printArea.width+'px'}" style="right: 0; top: 0; position: absolute"  :src="production_full_path_url" contain></v-img>
            </v-img>
        </div>

        <div class="d-flex flex-column px-4" style="background-color: white; border-top: 1px solid #E0E0E0; height:100%; justify-content: space-between">
            <p class="kanit-normal-2 fs-20 mt-4">{{ product.name }}</p>
            <table>
                <tr>
                    <td>
                        <span class="kanit-normal fs-14">Material</span>
                    </td>
                    <td>
                        <span class="kanit-normal fs-14">{{product.material}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="kanit-normal fs-14">Colours</span>
                    </td>
                    <td>
                        <div class="d-flex flex-row">
                            <div class="hover" v-for="color in productColors" >
                                <span v-if="!color.color_swatch" class="mr-1" style="font-weight: bold; border: 1px solid black;">{{color.color_name}}</span>
                                <v-img v-else class="mr-1" style="border-radius: 100%;" max-width="20px"  max-height="20px" contain :src="getSrc(color.color_swatch)"></v-img>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="kanit-normal fs-14">Sizes</span>
                    </td>
                    <td>
                        <span class="kanit-normal fs-14">{{ productSizes[0].value + '-' +  productSizes[1].value}}</span>
                    </td>
                </tr>
            </table>
            <p class="kanit-bold fs-20 mt-3 text-end">From {{getLowestPrice}} AUD</p>

        </div>

    </div>
</template>
<script>
export default {
    props:['product', 'production_full_path_url', 'fileWidth' ,'fileHeight'],
    data:()=>{
        return {
            dragging: false,
            imageContainerWidth: 0,
            imageContainerHeight: 0,
            sizes: ['XS','S','SM','M','MD','L','LG','XL','1XL','XXL','2XL','2X','XXXL','3XL','3X','XXXXL','4XL', '4X','XXXXXL','5XL','5X','XXXXXXL','6XL','6X'],

        }
    },
    methods: {
        addChosenProduct(){
            this.$emit('selectProduct', this.product);
        }
    },
    computed: {
        getLowestPrice(){
            let price = 9999;
            this.product.data.variants.forEach(variant=>{
                if(price > variant.total) price = variant.total;
            })
            price = parseFloat(price) + parseFloat(this.product.print_price);
            return price.toFixed(2);
        },
        printArea(){
            let ratio;
            let mockupWidth = 0;
            let mockupHeight = 0;
            let frontPrint;
            this.product.print_areas.forEach(print=>{
                if(print.side == 'front') frontPrint = print.data;
            })
            if(this.imageContainerWidth <= 0 || this.imageContainerHeight <= 0) return false;
            let widthRatio = this.imageContainerWidth/frontPrint.canvasWidth;

            let printWidth = frontPrint.width * widthRatio * 0.9;
            let heightRatio = this.imageContainerHeight/frontPrint.canvasHeight;
            let printHeight= frontPrint.height * heightRatio * 0.9;

            mockupWidth = this.fileWidth;
            if(mockupWidth > printWidth) mockupWidth = 0.9 * printWidth;

            mockupHeight = this.fileHeight;
            if(mockupHeight > printHeight) mockupHeight = 0.9 * printHeight;

            let newX = frontPrint.x * widthRatio + (printWidth - mockupWidth);
            let newY = frontPrint.y * heightRatio;


            return {
                x: newX,
                y: newY,
                height: mockupHeight,
                width: mockupWidth
            }
        },
        productInfo(){
            let colorsArray = []
            let sizesArray = []

            this.product.data.variants.forEach(item=>{
                if(sizesArray.indexOf(item.attributes[1].value) < 0) sizesArray.push(item.attributes[1].value);
                if(colorsArray.indexOf(item.attributes[0].value) < 0) colorsArray.push(item.attributes[0].value);
            });

            return {
                sizes: sizesArray.length,
                colors: colorsArray.length
            };
        },
        productSizes(){
            let item = this.product.data;
            let sizes = [];
            if(item.variants){
                item.variants.forEach(variant=>{
                    if(sizes.indexOf(variant.attributes[1].value) < 0) sizes.push(variant.attributes[1].value);
                });
            }

            let sizesToReturn = [];
            sizes.forEach(size=>{
                sizesToReturn.push({value: size})
            })

            sizesToReturn.forEach(item => {
                item.sizeIndex = this.sizes.indexOf(item.value);
            });
            sizesToReturn.sort(function (a, b) {
                return a.sizeIndex - b.sizeIndex;
            })

            return [sizesToReturn[0], sizesToReturn[sizesToReturn.length-1]];

        },
        productColors(){
            let item = this.product.data;
            let colors=[], selectedColors = [];
            if(item.variants){
                item.variants.forEach(variant=>{
                    console.log(variant)
                    if(variant.attributes && variant.attributes.length>0){
                        if(selectedColors.indexOf(variant.attributes[0].value) < 0) {
                            selectedColors.push(variant.attributes[0].value);
                            let obj = {
                                color_name: variant.attributes[0].value,
                                color_swatch: variant.color_swatch,
                            }

                            colors.push(obj);
                        }
                    }

                });
            }
            return colors;
        },

    },
    mounted() {
        let inter = setInterval(()=>{
            if(document.getElementById(this.product.id) && document.getElementById(this.product.id).offsetWidth > 0 && document.getElementById(this.product.id).offsetHeight > 0){
                this.imageContainerWidth = document.getElementById(this.product.id).offsetWidth;
                this.imageContainerHeight = document.getElementById(this.product.id).offsetHeight;
                clearInterval(inter);
            }
        },100)
    }
}
</script>
